import { createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/logo.svg'
import _imports_1 from '../../../assets/logo_vertical.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c876802e")

_pushScopeId("data-v-c876802e")
const _hoisted_1 = { class: "page-header-main" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 page-header-wrap" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "app-name" }, "COMMITTEE MEMBER", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("h4", null, "CANCEL APPLICATION", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("small", null, "By cancelling the Expression of Interest application all progress will be lost. Are you sure you want to cancel?", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_AccountInfoPanel = _resolveComponent("AccountInfoPanel")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: ["logo-main", _ctx.$route.name !== 'Dashboard' ? 'clickAllowed' : ''],
            ref: "headerLogo",
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => {_ctx.logoClick();}, ["prevent","stop"])),
            title: "The Law Society Of New South Wales Logo"
          }, [
            _createVNode("img", {
              class: "logo",
              src: _imports_0,
              alt: "The Law Society Of New South Wales Logo",
              title: _ctx.$route.name !== 'Dashboard' ? 'Home' : ''
            }, null, 8, ["title"]),
            _createVNode("img", {
              class: "logo-small",
              src: _imports_1,
              alt: "The Law Society Of New South Wales Logo",
              title: _ctx.$route.name !== 'Dashboard' ? 'Home' : ''
            }, null, 8, ["title"]),
            _hoisted_5
          ], 2),
          (_ctx.showAppMenu)
            ? (_openBlock(), _createBlock(_component_AccountInfoPanel, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showCancelAlertBox)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = $event => (_ctx.showCancelAlertBox = false))
        }, {
          header: _withId(() => [
            _hoisted_6
          ]),
          body: _withId(() => [
            _hoisted_7
          ]),
          footer: _withId(() => [
            _createVNode("button", {
              class: "btn btn-secondary sml",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.exitApplication()))
            }, "Yes"),
            _createVNode("button", {
              class: "btn btn-tertiary sml",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.showCancelAlertBox = false))
            }, "No")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})